import { Link, LinkProps } from "@mui/material";
import { FC } from "react";

interface SalifyLinkV2Props extends LinkProps {
  href: string | undefined;
}

export const SalifyLinkV2: FC<SalifyLinkV2Props> = ({ href, ...props }) => {
  return href ? (
    <Link
      href={href}
      {...props}
      sx={{
        textDecoration: "none",
        color: "inherit",
        ...props.sx,
      }}
    />
  ) : (
    props.children
  );
};
